export const SET_DATE_RANGE = "SET_DATE_RANGE";
export const SET_DATE_RANGE_PRESET = "SET_DATE_RANGE_PRESET";

export const DATE_RANGE_SCOPES = {
  AUDIT_LOGS: "audit_logs"
};

export const DATE_RANGE_STATE_KEYS = {
  [DATE_RANGE_SCOPES.AUDIT_LOGS]: "auditLogsDateRange"
};

export const setDateRange = (
  startDate,
  endDate,
  preset = "custom",
  scope = DATE_RANGE_SCOPES.AUDIT_LOGS
) => ({
  type: SET_DATE_RANGE,
  meta: { scope },
  payload: {
    startDate,
    endDate,
    preset
  }
});
